<template>
  <section
    class="my-8 md:mb-8 mx-auto bg-black pt-6 px-2 md:px-10 pb-0 shadow-black shadow-xl divide-y-2 divide-white text-[#999999] text-[22px] max-w-[1400px]"
  >
    <RallyLogoDownload />
    <div class="pt-8 mt-8 flex flex-col gap-4">
      <h1 class="text-white text-2xl md:text-3xl font-russo">
        ROAD RALLY ROADBOOK SPECIFICATION
      </h1>
      <GuideDownloadCta />
      <h2 class="text-[#FF0000] hover:underline font-black">
        <a
          href="https://www.fia.com/system/files/documents/wrc_2026_sr_version_13_january_2026.pdf"
          target="_blank"
          rel="noopener"
        >
          2026 FIA World Rally Championship Sporting Regulations
        </a>
      </h2>
      <h2 class="text-white font-russo text-[20px] md:text-[24px]">
        Built to the WRC Rules
      </h2>
      <p class="font-arial text-[#A9A9A9] text-[15px] md:text-[17px] text-left">
        Rally Navigator numbers every time control the FIA way (TC1A,
        TC1B&#8230;) and takes target times as h:mm. A Regroup Out starts a new
        section and page, just as the regulations define a section. Pro users can
        add Service, Flexi Service, Remote Service, Tyre Fitting, Parc
        Ferm&eacute; and Technical zones.
      </p>
    </div>
    <div class="py-8 mt-8 flex flex-col gap-4">
      <h2 class="hover:underline font-semibold">Road Rally Control Zones</h2>
      <picture class="contents">
        <source srcset="/images/fia-roadbook-specs-rules/FIA-Road-Rally-Roadbook-Control-Signage.webp" type="image/webp" />
        <img
        decoding="async"
        fetchpriority="high"
        width="733"
        height="977"
        src="/images/fia-roadbook-specs-rules/FIA-Road-Rally-Roadbook-Control-Signage.png"
        class="flex m-auto"
        alt="FIA road rally roadbook control signage"
        />
      </picture>
      <h2 class="hover:underline font-semibold">FIA Roadbook Specifications</h2>
      <picture class="contents">
        <source srcset="/images/fia-roadbook-specs-rules/FIA-Road-Rally-Roadbook-Spec.webp" type="image/webp" />
        <img
        decoding="async"
        width="739"
        height="1033"
        src="/images/fia-roadbook-specs-rules/FIA-Road-Rally-Roadbook-Spec.png"
        class="flex m-auto"
        alt="FIA road rally roadbook specification"
        />
      </picture>
      <picture class="contents">
        <source srcset="/images/fia-roadbook-specs-rules/FIA-Road-Rally-Roadbook-Spec-2.webp" type="image/webp" />
        <img
        decoding="async"
        width="735"
        height="767"
        src="/images/fia-roadbook-specs-rules/FIA-Road-Rally-Roadbook-Spec-2.png"
        class="flex m-auto"
        alt="FIA road rally roadbook specification page 2"
        />
      </picture>
    </div>
    <GuideDownloadCta />
  </section>
  <section class="my-8 mx-auto max-w-[1400px]">
    <FeaturesBanner />
    <PartnersSmall />
    <RallyLogoDownload />
  </section>
  <RelatedGuides
    :links="[
        { to: '/how-to-create-a-road-rally', text: 'How to Create a Road Rally Roadbook' },
        { to: '/fim-fia-roadbook-specs-rules', text: 'FIM/FIA Cross Country Roadbook Specs' },
        { to: '/time-speed-distance', text: 'Time Speed Distance Rally' },
        { to: '/rally-roadbook', text: 'What Is a Rally Roadbook?' },
      ]"
  />
</template>

<script>
import FeaturesBanner from './FeaturesBanner.vue';
import RelatedGuides from './RelatedGuides.vue';
import GuideDownloadCta from './GuideDownloadCta.vue';
import PartnersSmall from './PartnersSmall.vue';
import RallyLogoDownload from './RallyLogoDownload.vue';

export default {
  name: 'RoadStageFIASpecsRules',
  components: {
    GuideDownloadCta,
    FeaturesBanner,
    RelatedGuides,
    RallyLogoDownload,
    PartnersSmall,
  },
};
</script>

<style scoped></style>
